<template>
  <div id="header-clover" v-if="isLogin">
    <div class="header-clover-wrapper">
      <img class="clover-img" :src="`${$s3}/img/common/Header/clover.webp?${$ver}`" />
      <roller class="header-clover" :text="String(usrClover)" :isNumberFormat="true" :transition="0.5"></roller>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Roller from 'vue-roller';

export default {
  name: 'HeaderClover',
  components: {
    Roller,
  },
  computed: {
    ...mapState(['isLogin', 'isMobile', 'usrClover']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

#header-clover {
  min-width: fit-content;
  color: #fff;
  font-size: 32px;
  font-weight: 700;

  @include tablet {
    font-size: 16px;
  }

  .header-clover-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;

    .d-flex {
      display: flex;
    }
    img.clover-img {
      height: 26px;
      transform: rotate(45deg);

      @include tablet {
        height: 14px;
      }
    }
  }
}
</style>
